<template>
	<page>
		<module title="详情页">
			<c-detail title="详情页">
				<c-detail-item label="详情">
					撒打算大所
				</c-detail-item>
				
				<c-detail-item label="详情">
					撒打算大所
				</c-detail-item>
				
				<c-detail-item label="详情" full>
					<c-table v-model="tableData" height="auto" border>
						<c-table-column
							label="用户名"
						>
							姓名
						</c-table-column>
						
						<c-table-column
							label="姓名"
						></c-table-column>
						
						<c-table-column
							label="所属站点"
						></c-table-column>
					</c-table>
				</c-detail-item>
			</c-detail>
			
			<c-detail title="详情页">
				<c-detail-item label="详情">
					撒打算大所
				</c-detail-item>
				<c-detail-item label="详情">
					撒打算大所
				</c-detail-item>
				<c-detail-item label="详情" full>
					<c-image src="http://placehold.it/750x750/666/fff.png" size="120" preview></c-image>
				</c-detail-item>
			</c-detail>
			
			<template slot="button">
				<c-button size="m" @click="$refs.memberSelector.open()">提交发布</c-button>
				<c-button size="m" hollow @click="$refs.productSelector.open()">暂存草稿</c-button>
			</template>
		</module>
		
		<member-selector ref="memberSelector" multiple @resolve="callback"></member-selector>
		<product-selector ref="productSelector" @resolve="callback"></product-selector>
	</page>
</template>

<script>
	import memberSelector from '@/components/service/member_selector.vue'
	import productSelector from '@/components/service/product_selector.vue'
	
	export default {
		name: 'detailName',
		
		components: {
			memberSelector, productSelector
		},
		
		data() {
			return {
				tableData: [{
					name: '选项一',
					value: 1
				}, {
					name: '选项二',
					value: 2
				}, {
					name: '选项三',
					value: 3
				}]
			}
		},
		
		methods: {
			callback(data) {
				console.log(data);
			}
		}
	}
</script>